import {BankBilletData} from './bank-billet-data';
import {Contract} from './contract';
import {CreditCardData} from './credit-card-data';
import {PaymentMethodOption} from './payment-method-option';
import {UpgradeData} from './upgrade-data';
import {CustomerAccount} from './customer-account';
import {ShopWindowItem} from './shop-window-item';
import {Messages} from './messages';
import { PixData } from './pix-data';
import { PaymentConditionOption } from './payment-condition-option';

export class SelfAttendanceData {

  contract: Contract;
  bankBilletData: BankBilletData;
  pixData: PixData;
  creditCardData: CreditCardData;
  upgradeData: UpgradeData;
  paymentOptions: Array<PaymentMethodOption>;

  account: CustomerAccount;
  packages: Array<ShopWindowItem>;
  selectedPackage: ShopWindowItem;
  newPaymentCondition: PaymentConditionOption;

  success: boolean;
  isInvestigate: boolean;
  refund: boolean;
  result: string;
  paymentMethod: string;
  service: string;
  automaticRecharge: number;
  businessId: string;
  userId: string;

  tdu: string;

  messages: Messages;

  errorRFB: boolean;

  redirectURL: string;

  bonusAmount: any;
  bonus: string;

  constructor(selfAttendanceData?: any) {
    if (selfAttendanceData) {
      this.success = selfAttendanceData.success;
      this.refund = selfAttendanceData.refund || null;
      this.result = selfAttendanceData.result;
      this.service = selfAttendanceData.service;
      this.errorRFB = selfAttendanceData.errorRFB;
      this.automaticRecharge = selfAttendanceData.automaticRecharge;
      this.redirectURL = selfAttendanceData.redirectUrl;
      this.newPaymentCondition = selfAttendanceData.newPaymentCondition;

      this.userId = selfAttendanceData.userId;
      this.businessId = selfAttendanceData.businessId;
      this.paymentMethod = selfAttendanceData.paymentMethod;

      this.tdu = selfAttendanceData.tdu;
      this.bonusAmount = selfAttendanceData.bonusAmount;
      this.bonus = selfAttendanceData.bonus;

      if (selfAttendanceData.account) {
        this.account = new CustomerAccount(selfAttendanceData.account);
      }

      if (selfAttendanceData.contract) {
        this.contract = new Contract(selfAttendanceData.contract);
      } else if (selfAttendanceData.order) {
        this.contract = new Contract(selfAttendanceData.order);
      }

      if (selfAttendanceData.isInvestigate) {
        this.isInvestigate = selfAttendanceData.isInvestigate;
      }

      if (selfAttendanceData.upgradeData) {
        this.upgradeData = new UpgradeData(selfAttendanceData.upgradeData);
      }

      if(selfAttendanceData.selectedPackage) {
        this.selectedPackage = new ShopWindowItem(selfAttendanceData.selectedPackage);
      }

      if (selfAttendanceData.paymentOptions) {
        this.paymentOptions = selfAttendanceData.paymentOptions.map(po => new PaymentMethodOption(po));
      }

      if (selfAttendanceData.bankBilletData) {
        this.bankBilletData = new BankBilletData(selfAttendanceData.bankBilletData);
      }
      if (selfAttendanceData.pixData) {
        this.pixData = new PixData(selfAttendanceData.pixData);
      }

      if (selfAttendanceData.creditCardData) {
        this.creditCardData = new CreditCardData(selfAttendanceData.creditCardData);
      }

      if (selfAttendanceData.packages && selfAttendanceData.packages.length) {
        this.packages = selfAttendanceData.packages.map(pkg => new ShopWindowItem(pkg));
      }

      if (selfAttendanceData.messages) {
        this.messages = new Messages(selfAttendanceData.messages);
      }
    }
  }
}
